module.exports = __webpack_public_path__ + "static/media/product-1.bd865a62.png";